import classNames from 'classnames';
import { memo, useCallback, useMemo } from 'react';
import I18n from 'I18n';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { parseMultiEnumValue, formatMultiEnumValue } from 'customer-data-property-utils/parseMultiEnumValue';
import DomainPopoverContent from './domain/DomainPopoverContent';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputMultipleDomain = ({
  value,
  additionalDomains,
  onChangeMultiple,
  popoverOpen,
  popoverProps,
  property,
  readOnly = false,
  disabled = false,
  setPopoverOpen,
  className,
  showAutoSaveText = false
}) => {
  const handleShowPopover = useCallback(() => {
    // We don't want to allow opening the popover if the input is disabled or
    // read only
    if (readOnly || disabled) {
      return;
    }
    setPopoverOpen(true);
  }, [disabled, readOnly, setPopoverOpen]);
  const domains = useMemo(() => {
    const result = [value || ''];
    if (!additionalDomains) {
      return result;
    }
    return [...result, ...parseMultiEnumValue(additionalDomains)];
  }, [value, additionalDomains]);
  const onDomainsChanged = newDomains => {
    const primaryDomainValue = newDomains[0];
    const secondaryDomainValue = formatMultiEnumValue(newDomains.slice(1));
    onChangeMultiple(Object.assign({}, primaryDomainValue !== value ? {
      [property.name]: primaryDomainValue
    } : undefined, secondaryDomainValue !== additionalDomains ? {
      hs_additional_domains: secondaryDomainValue
    } : undefined));
  };
  const handleChangeDomain = (index, domain) => {
    const updatedValue = [...domains];
    updatedValue[index] = domain;
    onDomainsChanged(updatedValue);
  };
  const handleAddDomain = newDomain => {
    const updatedValue = [...domains, newDomain];
    onDomainsChanged(updatedValue);
  };
  const handleRemoveDomain = domainToRemove => {
    const updatedValue = domains.filter(domain => domain !== domainToRemove);
    onDomainsChanged(updatedValue);
  };
  const handlePromoteDomain = domainToPromote => {
    const valueWithoutPromotedDomain = domains.filter(domain => domain !== domainToPromote);
    const updatedValue = [domainToPromote, ...valueWithoutPromotedDomain];
    onDomainsChanged(updatedValue);
  };
  const popoverContent = /*#__PURE__*/_jsx(DomainPopoverContent, {
    domains: domains,
    onChangeDomain: handleChangeDomain,
    onRemoveDomain: handleRemoveDomain,
    onPromoteDomain: handlePromoteDomain,
    onAddDomain: handleAddDomain,
    showAutoSaveText: showAutoSaveText
  });
  const readOnlyValueClassNames = classNames(className, value === '' ? 'p-bottom-5' : 'p-top-1');
  return /*#__PURE__*/_jsx(UIGridItem, {
    size: {
      xs: 12
    },
    className: "p-x-0",
    children: /*#__PURE__*/_jsx(UIPopover, Object.assign({
      closeOnOutsideClick: true,
      width: 350,
      placement: "right"
    }, popoverProps, {
      open: popoverOpen,
      onOpenChange: evt => setPopoverOpen(evt.target.value),
      content: popoverContent,
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "domain-input",
        className: readOnlyValueClassNames,
        onClick: handleShowPopover,
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: I18n.formatList(domains)
        })
      })
    }))
  });
};
export default /*#__PURE__*/memo(PropertyInputMultipleDomain);